var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom";
import { BasicFormFormat } from "../../UI/FormFormat/FormFormat";
import InputField from "../../Form/InputField";
import SelectField from "../../Form/SelectField";
const LinkTargetSettings = {
    thisWindow: {
        label: "This window",
        value: false,
    },
    newWindow: {
        label: "New window",
        value: "_blank",
    },
};
const LinkEditor = ({ editor, }) => {
    const saveButtonRef = React.useRef(null);
    // Retrieves current link settings to use as modal default values
    const getLinkSettings = () => {
        const component = editor.getSelected();
        if (component) {
            const attributes = component.getAttributes();
            return {
                content: component.getLastChild().get("content") || "",
                href: attributes.href || "",
                target: attributes.target
                    ? LinkTargetSettings.newWindow
                    : LinkTargetSettings.thisWindow,
            };
        }
        return {
            content: "",
            href: "",
            target: LinkTargetSettings.thisWindow,
        };
    };
    // Updates current selected link settings
    const handleSave = (formState) => {
        var _a, _b;
        const component = editor.getSelected();
        if (component) {
            const attributes = component.getAttributes();
            attributes.href = formState.href;
            attributes.target = (_b = (_a = formState.target) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : false;
            component.setAttributes(attributes);
            component.getLastChild().set("content", formState.content);
            component.view.render();
            editor.Modal.close();
        }
    };
    // Removes the current selected link properties keeping only the text
    const handleRemoveLink = () => {
        const component = editor.getSelected();
        if (component) {
            const currentLinkContent = component.getLastChild().get("content");
            // Because of MJML, we have nested html tags, this forces us to manually
            // replace the existing text instead of just simply clearing the link
            const coll = component.collection;
            const at = coll.indexOf(component);
            coll.remove(component);
            coll.add(currentLinkContent, { at });
            editor.Modal.close();
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs(BasicFormFormat, { handleSubmit: (formState) => __awaiter(void 0, void 0, void 0, function* () { return handleSave(formState); }), defaultValue: getLinkSettings(), saveButtonRef: saveButtonRef, hideButtons: true, children: [_jsx(InputField, { name: "content", label: "Text", placeholder: "Enter your link text", required: true }), _jsx(InputField, { name: "href", label: "URL", placeholder: "Enter your link URL", required: true }), _jsx(SelectField, { label: "Target", name: "target", options: [
                            { label: "This window", value: false },
                            { label: "New window", value: "_blank" },
                        ], clearable: false, required: true })] }), _jsxs("div", { className: "d-flex justify-content-between", children: [_jsx("div", { children: _jsx("button", { type: "button", className: "btn btn-secondary mr-2", onClick: handleRemoveLink, children: "Remove Link" }) }), _jsxs("div", { className: "d-flex", children: [_jsx("button", { type: "button", className: "btn btn-primary", onClick: () => { var _a; return (_a = saveButtonRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, children: "Save" }), _jsx("button", { type: "button", className: "btn btn-outline-secondary ml-2 ", onClick: () => editor.Modal.close(), children: "Cancel" })] })] })] }));
};
export const ModalLinkEditor = (editor) => {
    editor.Commands.add("open-link-editor", {
        run: () => {
            editor.Modal.setTitle('<div class="modal-title h4">Edit Link</div>')
                .setContent('<div id="link-editor-root"></div>')
                .open();
            ReactDOM.render(_jsx(LinkEditor, { editor: editor }), document.getElementById("link-editor-root"));
        },
    });
    // Modify RTE link action
    const linkRTEAction = editor.RichTextEditor.get("link");
    linkRTEAction.result = (rte) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        // Get the current selection from the RTE
        const selection = rte.selection();
        // Check if there's a valid selection in the RTE
        if (!selection || selection.isCollapsed) {
            console.error("No text selection for link found");
            return;
        }
        // We add a random id seed to the newly created link href to allow for proper manipulation down in the flow
        const randomIdSeed = Math.floor(Math.random() * 10000);
        rte.exec("createLink", randomIdSeed);
        (_a = editor.getSelected()) === null || _a === void 0 ? void 0 : _a.view.disableEditing();
        const wrapper = yield editor.DomComponents.getWrapper();
        const linkComponent = wrapper.find(`a[href='${randomIdSeed}']`)[0];
        if (linkComponent) {
            // Manually selects the created component inside the editor to allow the edit link modal to interact with the selection
            editor.select(linkComponent);
            const currentAttributes = linkComponent.get("attributes");
            linkComponent.set("attributes", Object.assign(Object.assign({}, currentAttributes), { 
                // By default, we will add the current text link as the link's href
                href: linkComponent.getLastChild().get("content") }));
            editor.runCommand("open-link-editor");
        }
        else {
            console.error("Could not find inserted link");
        }
    });
};
